import React from 'react';

// alerts
import Alerts from './components/Alerts/Alerts';

// Components
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';
import GlobalStyle from './layout/components/GlobalStyle/GlobalStyle';
import NotificationBanner from './components/NotificationBanner/NotificationBanner';

// Containers
import AuthContainer from './auth/containers/AuthContainer/AuthContainer';

// Departments
import DepartmentsContainer from './department/containers/DepartmentsContainer/DepartmentsContainer';

// Routes
import Routes from './routes/Routes';

// Context
import { AppProviders } from './contexts';

const App = () => {
  return (
    <ErrorBoundary>
      <AppProviders>
        <GlobalStyle />
        <AuthContainer>
          <DepartmentsContainer>
            <NotificationBanner />
            <Routes />
          </DepartmentsContainer>
        </AuthContainer>
        <Alerts />
      </AppProviders>
    </ErrorBoundary>
  );
};

export default App;
